import React, { useCallback, useEffect, useState, useContext } from 'react';
import { getWarehouses, deleteWarehouse, apiClient, getBranch } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import WarehouseForm from './form';
import '../../../Utility/pagination.css'
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';
import { useLocation } from 'react-router-dom';


const Warehouse_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [warehouses, setWarehouses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, showdeleteModal] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [branch, setBranchs] = useState([]);

  const rolesPerPage = 10;

  useEffect(() => {
    fetchWarehouse(currentPage);
    fetchBranchs()
  }, [currentPage]);

  const handledeletemodule = (ID) => {
    showdeleteModal(true);
    setDeleteID(ID)
  }

  const fetchWarehouse = async (page = 1, text = "") => {
    showLoader();
    try {
      const response = await getWarehouses(page, text);
      if (response.data && response.data.data) {
        setWarehouses(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      toast.error('Error fetching warehouses');
      hideLoader();
    }
  };

  const fetchBranchs = useCallback(async (page = 1, text = "") => {
    try {
      const response = await getBranch();
      if (response.data?.data) {
        setBranchs(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const openModal = (warehouse = null) => {
    setSelectedWarehouse(warehouse);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteWarehouse(DeleteID);
      toast.success('Warehouse deleted successfully');
      fetchWarehouse(currentPage);
      showdeleteModal(false);
      await fetchWarehouse();

    } catch (error) {
      toast.error('Error deleting warehouse');
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchWarehouse(currentPage);
  };

  const handleSearch = async (text) => {
    fetchWarehouse(1, text);
    setCurrentPage(1);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Warehouse list</h6>
          {!readonly && <button type="button" onClick={() => openModal()} className="btn btn-primary mb-0" style={{ fontFamily: "poppins" }}>
            Add Warehouse
          </button>}
        </div>
        <hr className='mt-1' />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div className="d-flex position-relative" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table id="example" className="table table-striped table-sm table-bordered align-baseline" style={{ width: "100%", fontFamily: "poppins" }}>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Image</th>
                    <th>Status</th>
                    {!readonly && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {warehouses.map((warehouse, index) => (
                    <tr key={warehouse.id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{warehouse.title}</td>
                      <td>{warehouse.address}</td>
                      <td>{warehouse.email}</td>
                      <td>{warehouse.phone}</td>
                      <td>
                        <img src={warehouse?.image ?
                          `${apiClient.defaults.baseURL}${warehouse.image}` : "./../assets/images/warehouse1.png"
                        } alt="Warehouse" height="40" width="40" style={{ objectFit: "cover" }} />
                      </td>
                      <td>{warehouse.status === '1' ? 'Active' : 'Inactive'}</td>
                      {!readonly && <td>
                        <img src='/assets/images/icons/edit.png' onClick={() => openModal(warehouse)} height={"20px"} />
                        <img src='/assets/images/icons/delete.png' className="mx-1" onClick={() => handledeletemodule(warehouse.id)} height={"20px"} />
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />

            </div>
          </div>
        </div>
      </div>

      {deleteModal && (
        <Deletemodel
          setShowModal={showdeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <WarehouseForm
          warehouse={selectedWarehouse}
          closeModal={() => setShowModal(false)}
          refreshList={fetchWarehouse}
        />
      )}
    </div>
  )
}

export default Warehouse_list;

